export const SEARCH_JOBS_PENDING = 'SEARCH_JOBS_PENDING';
export const SEARCH_JOBS_SUCCESS = 'SEARCH_JOBS_SUCCESS';
export const SEARCH_JOBS_ERROR = 'SEARCH_JOBS_ERROR';
export const GET_JOBS_PENDING = 'GET_JOBS_PENDING';
export const GET_JOBS_SUCCESS = 'GET_JOBS_SUCCESS';
export const GET_JOBS_ERROR = 'GET_JOBS_ERROR';
export const UPDATE_JOB_PENDING = 'UPDATE_JOB_PENDING';
export const UPDATE_JOB_SUCCESS = 'UPDATE_JOB_SUCCESS';
export const UPDATE_JOB_ERROR = 'UPDATE_JOB_ERROR';
export const CREATE_JOB_PENDING = 'CREATE_JOB_PENDING';
export const CREATE_JOB_SUCCESS = 'CREATE_JOB_SUCCESS';
export const CREATE_JOB_ERROR = 'CREATE_JOB_ERROR';
export const REMOVE_JOB_PENDING = 'REMOVE_JOB_PENDING';
export const REMOVE_JOB_SUCCESS = 'REMOVE_JOB_SUCCESS';
export const REMOVE_JOB_ERROR = 'REMOVE_JOB_ERROR';
export const GET_JOB_PENDING = 'GET_JOB_PENDING';
export const GET_JOB_SUCCESS = 'GET_JOB_SUCCESS';
export const GET_JOB_ERROR = 'GET_JOB_ERROR';
export const GET_APPLICANTS_PENDING = 'GET_APPLICANTS_PENDING';
export const GET_APPLICANTS_SUCCESS = 'GET_APPLICANTS_SUCCESS';
export const GET_APPLICANTS_ERROR = 'GET_APPLICANTS_ERROR';
export const APPLY_JOB_PENDING = 'APPLY_JOB_PENDING';
export const APPLY_JOB_SUCCESS = 'APPLY_JOB_SUCCESS';
export const APPLY_JOB_ERROR = 'APPLY_JOB_ERROR';
export const UNAPPLY_JOB_PENDING = 'UNAPPLY_JOB_PENDING';
export const UNAPPLY_JOB_SUCCESS = 'UNAPPLY_JOB_SUCCESS';
export const UNAPPLY_JOB_ERROR = 'UNAPPLY_JOB_ERROR';
export const GET_APPLICANT_JOBS_PENDING = 'GET_APPLICANT_JOBS_PENDING';
export const GET_APPLICANT_JOBS_SUCCESS = 'GET_APPLICANT_JOBS_SUCCESS';
export const GET_APPLICANT_JOBS_ERROR = 'GET_APPLICANT_JOBS_ERROR';
export const GET_EMPLOYER_JOBS_PENDING = 'GET_EMPLOYER_JOBS_PENDING';
export const GET_EMPLOYER_JOBS_SUCCESS = 'GET_EMPLOYER_JOBS_SUCCESS';
export const GET_EMPLOYER_JOBS_ERROR = 'GET_EMPLOYER_JOBS_ERROR';
export const GET_APPLIED_JOBS_PENDING = "GET_APPLIED_JOBS_PENDING"
export const GET_APPLIED_JOBS_SUCCESS = "GET_APPLIED_JOBS_SUCCESS"
export const GET_APPLIED_JOBS_ERROR = "GET_APPLIED_JOBS_ERROR"

export function getApplicantJobsPending() {
  return { type: GET_APPLICANT_JOBS_PENDING }
};

export function getApplicantJobsSuccess(payload) {
  return { type: GET_APPLICANT_JOBS_SUCCESS, payload }
};

export function getApplicantJobsError(error) {
  return { type: GET_APPLICANT_JOBS_ERROR, error }
};

export function getEmployerJobsPending() {
  return { type: GET_EMPLOYER_JOBS_PENDING }
};

export function getEmployerJobsSuccess(payload) {
  return { type: GET_EMPLOYER_JOBS_SUCCESS, payload }
};

export function getEmployerJobsError(error) {
  return { type: GET_EMPLOYER_JOBS_ERROR, error }
};

export function getJobsPending() {
  return { type: GET_JOBS_PENDING }
};

export function getJobsSuccess(payload) {
  return { type: GET_JOBS_SUCCESS, payload }
};

export function getJobsError(error) {
  return { type: GET_JOBS_ERROR, error }
};

export function getJobPending() {
  return { type: GET_JOB_PENDING }
};

export function getJobSuccess(payload) {
  return { type: GET_JOB_SUCCESS, payload }
};

export function getJobError(error) {
  return { type: GET_JOB_ERROR, error }
};

export function createJobPending() {
  return { type: CREATE_JOB_PENDING }
};

export function createJobSuccess(payload) {
  return { type: CREATE_JOB_SUCCESS, payload }
};

export function createJobError(error) {
  return { type: CREATE_JOB_ERROR, error }
};

export function updateJobPending() {
  return { type: UPDATE_JOB_PENDING }
};

export function updateJobSuccess(payload) {
  return { type: UPDATE_JOB_SUCCESS, payload }
};

export function updateJobError(error) {
  return { type: UPDATE_JOB_ERROR, error }
};

export function searchJobsPending() {
  return { type: SEARCH_JOBS_PENDING }
};

export function searchJobsSuccess(payload) {
  return { type: SEARCH_JOBS_SUCCESS, payload }
};

export function searchJobsError(error) {
  return { type: SEARCH_JOBS_ERROR, error }
};

export function applyJobPending() {
  return { type: APPLY_JOB_PENDING }
};

export function applyJobSuccess(payload) {
  return { type: APPLY_JOB_SUCCESS, payload }
};

export function applyJobError(error) {
  return { type: APPLY_JOB_ERROR, error }
};

export function unapplyJobPending() {
  return { type: UNAPPLY_JOB_PENDING }
};

export function unapplyJobSuccess(payload) {
  return { type: UNAPPLY_JOB_SUCCESS, payload }
};

export function unapplyJobError(error) {
  return { type: UNAPPLY_JOB_ERROR, error }
};

export function removeJobPending() {
  return { type: REMOVE_JOB_PENDING }
};

export function removeJobSuccess(payload) {
  return { type: REMOVE_JOB_SUCCESS, payload }
};

export function removeJobError(error) {
  return { type: REMOVE_JOB_ERROR, error }
};

export function getApplicantsPending() {
  return { type: GET_APPLICANTS_PENDING }
};

export function getApplicantsSuccess(payload) {
  return { type: GET_APPLICANTS_SUCCESS, payload }
};

export function getApplicantsError(error) {
  return { type: GET_APPLICANTS_ERROR, error }
};

export function getAppliedJobsPending() {
  return { type: GET_APPLIED_JOBS_PENDING }
};

export function getAppliedJobsSuccess(payload) {
  return { type: GET_APPLIED_JOBS_SUCCESS, payload }
};

export function getAppliedJobsError(error) {
  return { type: GET_APPLIED_JOBS_ERROR, error }
};
